<template>
    <ul class="nav navbar-nav float-lg-right mai-user-nav">
        <li class="dropdown nav-item" v-bind:class="{open: isOpen}">
            <a href="#" @click.stop="toggleMenu()" class="dropdown-toggle nav-link">
                <span class="user-name">{{ this.$store.state.user.name }}</span><span
                    class="angle-down s7-angle-down"></span>
                <span class="subtitle" v-if="overlaying">{{ overlayUser }}</span>
            </a>

            <div role="menu" class="dropdown-menu">
                <router-link :to="{name: 'dashboard'}" active-class="active" class="dropdown-item" exact><span class="icon s7-display1" > </span>{{ $t('topmenu.my_units') }}</router-link>
                <router-link :to="{name: 'profile'}" active-class="active" class="dropdown-item"><span class="icon s7-user"> </span>{{ $t('topmenu.my_profile') }}</router-link>
                <a @click="handleLogout()" class="dropdown-item"> <span class="icon s7-power"> </span>{{ $t('topmenu.logout') }}</a></div>
        </li>
    </ul>
</template>

<script>
    import auth from "../../../utils/auth"

    export default {
        data (){
          return {
              isOpen: false
          }
        },
        computed: {
            overlaying(){
                return this.overlayUser !== ""
            },
            overlayUser(){
                let contextUser = this.$store.getters.getContextUser
                if(contextUser !== null && contextUser.id !== this.$store.state.user.id)
                    return this.$store.getters.getContextUser.name;
                else
                    return ""
            }
        },
        methods: {
            toggleMenu() {
                this.isOpen = !this.isOpen;

                if(this.isOpen)
                {
                    // Register event listener
                    document.addEventListener('click', this.closeMenu)
                } else {
                    // Cleanup
                    closeMenu();
                }
            },
            handleLogout() {
                auth.logout();
            },
            closeMenu() {
                this.isOpen = false;
                document.removeEventListener('click', this.closeMenu)
            }
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/layout/topbar/usermenu.vue